import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import Dialog from '~/components/Dialog'
import { handleErrors } from '~/utils/helpers'
import { StyledCheckbox } from './style'
import ClimaCheckService from '~/api/services/climaCheck'

interface Props {
  isOpen: boolean
  handleClose: (checked: boolean) => void
}

const PreviewModal: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { isOpen, handleClose } = props
  const { id } = useParams()
  const refIframe = useRef(null)

  const [isBusy, setIsBusy] = useState(false)
  const [fileSource, setFileSource] = useState('')
  const [isNoShowChecked, setIsNoShowChecked] = useState(false)

  useEffect(() => {
    if (isOpen) {
      fetchFileSource()
    }
  }, [isOpen])

  async function fetchFileSource() {
    setIsBusy(true)
    try {
      const response = await ClimaCheckService.getClimaChPreviewFile(id)
      setFileSource(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderPreviewFile() {
    return <div style={{ position: 'relative', width: '100%', minHeight: '500px', height: '93%' }}>
      <iframe
        ref={refIframe}
        src={fileSource ? `${fileSource}#toolbar=1&navpanes=0&view=FitH` : 'about:blank'}
        width='100%'
        height='100%'
        style={{ minHeight: 500 }}
      />
      <StyledCheckbox
        label={t('Do not show again')}
        checked={isNoShowChecked}
        onChange={(e, data) => setIsNoShowChecked(data.checked)}
      />
    </div>
  }

  return <Dialog
    textHeader={t('Preview file')}
    heightContent={'90%'}
    heightDialog={'80%'}
    isDialogOpen={isOpen}
    noScrollingContent={false}
    style={{ width: '70%' }}
    isLoading={isBusy}
    textClose={t('Close')}
    handleClose={() => handleClose(isNoShowChecked)}
    type={'preview'}
    textContent={renderPreviewFile()}
  />
}
export default PreviewModal